if (!customElements.get('quick-view-modal')) {
  // Cache static pentru prefetch
  const quickViewCache = {};

  window.FoxTheme = window.FoxTheme || {};
  window.FoxTheme.prefetchQuickView = prefetchQuickView;

  // Prefetching the section HTML alone makes the text render instantly and
  // leaves the product photo arriving ~200ms later, so the modal opens with an
  // empty image box. Warm the first image off the prefetched markup so both
  // land together.
  function warmFirstImage(responseText) {
    try {
      const doc = new DOMParser().parseFromString(responseText, 'text/html');
      const img = doc.querySelector('.quick-view__content img, .product__media-wrapper img, img');
      if (!img) return;

      const src = img.getAttribute('src');
      const srcset = img.getAttribute('srcset');
      if (!src && !srcset) return;

      const warm = new Image();
      const sizes = img.getAttribute('sizes');
      if (sizes) warm.sizes = sizes;
      if (srcset) warm.srcset = srcset;
      if (src) warm.src = src;
    } catch (e) {
      // Warming is best-effort; never let it break the prefetch.
    }
  }

  function prefetchQuickView(productUrl) {
    if (!productUrl) return;
    const cleanUrl = productUrl.split('?')[0];

    let sectionId = FoxTheme.QuickViewSectionId || false;
    if (!sectionId) {
      const productQuickView = document.querySelector('.section-group-overlay-quick-view');
      if (productQuickView) {
        sectionId = FoxTheme.utils.getSectionId(productQuickView);
        FoxTheme.QuickViewSectionId = sectionId;
      }
    }
    if (!sectionId) return;

    const sectionUrl = `${cleanUrl}?section_id=${sectionId}`;

    if (quickViewCache[sectionUrl]) return;

    quickViewCache[sectionUrl] = fetch(sectionUrl)
      .then((response) => response.text())
      .then((responseText) => {
        quickViewCache[sectionUrl] = responseText;
        warmFirstImage(responseText);
        return responseText;
      })
      .catch((e) => {
        delete quickViewCache[sectionUrl];
        console.error(e);
      });
  }

  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();
        this.classesToRemoveOnLoad = 'drawer--loading';
        this.drawerBody = this.querySelector(this.selector);
      }
      get selector() {
        return '.quick-view__content';
      }
      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }
      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }
      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }
      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.add(this.classesToRemoveOnLoad);
      }
      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;
        if (!sectionId) {
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }
          FoxTheme.QuickViewSectionId = sectionId;
        }
        return sectionId;
      }
      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const sectionUrl = `${this.dataset.productUrl.split('?')[0]}?section_id=${sectionId}`;

        const processResponse = (responseText) => {
          const productElement = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(this.selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);
          FoxTheme.a11y.trapFocus(this, this.focusElement);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          document.dispatchEvent(
            new CustomEvent('quick-view:loaded', {
              detail: { productUrl: this.dataset.productUrl },
            })
          );
        };

        const cached = quickViewCache[sectionUrl];

        if (cached && typeof cached === 'string') {
          processResponse(cached);
        } else if (cached && typeof cached.then === 'function') {
          cached.then((responseText) => {
            if (responseText) processResponse(responseText);
          });
        } else {
          fetch(sectionUrl)
            .then((response) => response.text())
            .then((responseText) => {
              quickViewCache[sectionUrl] = responseText;
              processResponse(responseText);
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }
      setInnerHTML(element, innerHTML) {
        element.innerHTML = innerHTML;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
        this.classList.remove(this.classesToRemoveOnLoad);
      }
    }
  );
}